import { all, put, takeLatest } from 'redux-saga/effects';
import {
  ACCOUNT_SWITCH,
  ACCOUNT_SWITCH_SUCCESS,
  ACCOUNT_SWITCH_FAILED,
} from '../actions/HeaderActions';
import { TOKEN_ERROR, ACCESS_REMOVED } from '../actions/index';
import { defaultApi } from '../utils/axiosApi';
import { ACTIVE_COMPANY_NOT_FOUND } from '../actions/SigninActions';

export function* attempSwitchAccount(credentials) {
  const base = process.env.REACT_APP_API_BASE_URL;
  const companyId = credentials.credentials.company_id;

  // Set the active company so axiosApi sends X-Company-Id on the /me call.
  localStorage.setItem('active_company_id', companyId);

  const me = yield defaultApi(`${base}/user/me`, 'GET', undefined);

  if (me.response) {
    const d = me.response.data && me.response.data.data;
    if (!d) {
      yield put({
        type: ACCOUNT_SWITCH_FAILED,
        message: 'Unexpected server response',
      });
      return;
    }
    yield put({
      type: ACCOUNT_SWITCH_SUCCESS,
      message: 'Account switched',
      allProfile: d.allProfiles,
      activeProfiles: d.activeProfile,
      loggedInAccountType: d.loggedInAccountType,
      role_permission: d.role_permission,
    });
  } else if (me.error) {
    const { data } = me.error;
    if (data.status === 'Token_error') {
      yield put({ type: TOKEN_ERROR, message: data.message });
    } else if (data.status === 'company-not-found') {
      yield put({
        type: ACTIVE_COMPANY_NOT_FOUND,
        message: data.message,
        data: data.data,
      });
    } else if (data.status === 'access-removed') {
      yield put({
        type: ACCESS_REMOVED,
        message: data.message,
        data: data.data,
      });
    } else {
      yield put({ type: ACCOUNT_SWITCH_FAILED, message: data.message });
    }
  }
}

export function* switchAccount() {
  yield takeLatest(ACCOUNT_SWITCH, attempSwitchAccount);
}

export default function* rootSaga() {
  yield all([switchAccount()]);
}
